import gql from 'graphql-tag';

export default gql`
mutation UpdateImage(
        $uuidEndpoint: String!,
        $uuid: String!,
        $comment: String,
        $delay: Int,
    ) {
    updateImage(input:{
        uuidEndpoint: $uuidEndpoint,
        uuid: $uuid,
        comment: $comment,
        delay: $delay
    }) {
        __typename
    }
}
`;
